import { Route } from 'vue-router'
import { StoreOptions } from 'vuex'

export default {
  state: {},
  mutations: {},
  actions: {},
  modules: {},
} as StoreOptions<{ route: Route }>
